import { Flex, Tabs, type TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './team.module.scss';
import { Team as TeamModule } from '@modules/team';
import { PageHeader } from '@shared/ui/page-header';

export const Team = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'team' });

  const items: TabsProps['items'] = [
    {
      key: t('tabTitle'),
      label: t('tabTitle'),
      children: <TeamModule />,
    },
  ];

  return (
    <Flex className={styles.root}>
      <Flex vertical className={styles.container}>
        <PageHeader title={t('title')} />

        <Tabs defaultActiveKey={t('tabTitle')} items={items} className={styles.tabs} />
      </Flex>
    </Flex>
  );
};
